<template>
  <exercicio></exercicio>
</template>

<script>
import exercicio from '@/custom/exercicio'
var componentDefinition = {
  components: { exercicio },
  route: {
    name: 'QUESTOES',
    path: '/aluno/:idaluno/matricula/:idmatricula/bloco/:idbloco/questoes/:refresh?',
    meta: {
      title: 'Questões',
      hasErrorHandler: true,
      pergunta: true,
      hidden: true
    }
  },
  created: function () {
  },
  mounted: function () {
  },
  data: function () {
    return {}
  },
  methods: {
  }
}
export default componentDefinition
</script>
